import React, { useState, useEffect, useCallback } from 'react';
import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Media,
    Collapse,
    Form,
    Input,
    Button,
    TabPane
} from "reactstrap"
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import '../../components/Common/Common.css';
import { useDispatch, useSelector } from "react-redux";
import PeriodBtn from "../../components/Filter/PeriodBtn";
import { getAdminList, updateSalesOwner } from "../../store/actions"
import Select from "react-select";

const thBaseStyle = { display: 'flex', alignItems: "center", justifyContent: "center", gap: "3px" };
const accountTypesInfo = { "PT": "Trial", "FR": "Free", "PR": "Member" }

const columns = [
    { label: "Organization", isSortable: true, sortAsc: "ORA", sortDesc: "ORD", thSyle: thBaseStyle },
    { label: "Username", isSortable: true, sortAsc: "UNA", sortDesc: "UND", thSyle: { ...thBaseStyle, maxWidth: "220px" } },
    { label: "Subs type", isSortable: true, sortAsc: "SUA", sortDesc: "SUD", thSyle: thBaseStyle },
    { label: "JN", isSortable: true, sortAsc: "JNA", sortDesc: "JND", thSyle: thBaseStyle },
    { label: "Acc type", isSortable: true, sortAsc: "ATA", sortDesc: "ATD", thSyle: thBaseStyle },
    { label: "Sub start", isSortable: true, sortAsc: "SSA", sortDesc: "SSD", thSyle: thBaseStyle },
    { label: "Sub end", isSortable: true, sortAsc: "SEA", sortDesc: "SED", thSyle: thBaseStyle },
    { label: "WE start", isSortable: true, sortAsc: "WEA", sortDesc: "WED", thSyle: thBaseStyle },
    { label: "Cases uploaded", isSortable: true, sortAsc: "CUA", sortDesc: "CUD", thSyle: thBaseStyle },
    { label: "Cases contacted", isSortable: true, sortAsc: "CCA", sortDesc: "CCD", thSyle: thBaseStyle },
    { label: "Emails sent", isSortable: true, sortAsc: "ESA", sortDesc: "ESD", thSyle: thBaseStyle },
    { label: "Last contact date", isSortable: true, sortAsc: "LCA", sortDesc: "LCD", thSyle: thBaseStyle },
    { label: "Send rate", isSortable: true, sortAsc: "SRA", sortDesc: "SRD", thSyle: thBaseStyle },
    { label: "Sales owner", isSortable: false, sortAsc: "SRA", sortDesc: "SRD", thSyle: thBaseStyle },
]

function MemberStatistics({ activeTab, tabId, filterValidation }) {

    const dispatch = useDispatch();

    // Form open toggle
    const [isOpen, setIsOpen] = useState(true);
    const toggle = () => {
        setIsOpen(!isOpen);
    }

    const [salesOwnerUpdate, setSalesOwnerUpdate] = useState(null);

    const { loading, error, success, noticeStr, totalPage, statisticsList, statFromDate, statToDate, adminList } = useSelector(state => ({
        loading: state.admMemberStatistics.loading,
        error: state.admMemberStatistics.error,
        success: state.admMemberStatistics.success,
        noticeStr: state.admMemberStatistics.noticeStr,
        totalPage: state.admMemberStatistics.totalPage,
        statFromDate: state.admMemberStatistics.fromDate,
        statToDate: state.admMemberStatistics.toDate,
        statUpdatedDate: state.admMemberStatistics.statUpdatedDate,
        totalPage: state.admMemberStatistics.totalPage,
        statisticsList: state.admMemberStatistics.statisticsList,
        adminList: state.admMemberStatistics.adminList,
    }))

    const onPageChange = (curPage, perPage) => {
        filterValidation.setFieldValue("submitType", "view");

        if (curPage) {
            // setCurPageInput(curPage);
            filterValidation.setFieldValue("curPage", curPage);
        } else {
            // setCurPageInput(1);
            filterValidation.setFieldValue("curPage", 1);
        }

        if (perPage) {
            filterValidation.setFieldValue("perPage", perPage);
        }

        filterValidation.handleSubmit(filterValidation.values);
    }

    const capitalize = (str) => str.substring(0, 1).toUpperCase() + str.substring(1, str.length)

    const adminListOptions = adminList && Array.isArray(adminList) && adminList.length > 0 ?
        [{value: "", label: "Please designate a sales owner"}, ...adminList.map(a => ({ value: a.userNo, label: capitalize(a.userName) }))] : []

    useEffect(() => {
        dispatch(getAdminList())
    }, [])

    return (
        <TabPane style={activeTab === tabId ? { display: "block" } : { display: "none" }} tabId={tabId}>
            <Row>
                <Col lg={12}>
                    <Card>
                        <Link onClick={toggle} className="text-dark" to="#">
                            <div className="p-4">
                                <Media className="d-flex align-items-center">
                                    <div className="flex-shrink-0 me-3">
                                        <i className="uil uil-list-ul text-primary h2"></i>
                                    </div>
                                    <div className="flex-grow-1 overflow-hidden">
                                        <h5 className="font-size-16 mb-1">Member Statistics</h5>
                                        <p className="text-muted mb-0">
                                            Use this tool to view member statistics on system usage based on the selected criteria.
                                            <br />Note: The selected From Date / To Date applies only to filtering subscription start dates.
                                            <span className='text-danger'> It does not affect the calculation of statistics such as Cases uploaded, Cases contacted, Emails sent, or Send rate. </span>
                                            These statistics are calculated daily based on a fixed reporting window of the past 2 months.
                                        </p>
                                    </div>
                                    <i className="uil uil-filter font-size-24 text-muted"></i>
                                </Media>
                            </div>
                        </Link>
                        <Collapse isOpen={isOpen}>
                            <div className="p-4 border-top">
                                <Row className="mb-3">
                                    <label
                                        htmlFor="member"
                                        className="col-md-2 col-form-label"
                                    >
                                        Member
                                    </label>
                                    <div className="col-md-3">
                                        <Input
                                            className="form-control"
                                            type="text"
                                            placeholder="Member"
                                            id="member"
                                            name="member"
                                            onChange={filterValidation.handleChange}
                                            value={filterValidation.values.member}
                                        />
                                    </div>
                                </Row>
                                {
                                    adminList && adminList.length > 0 &&
                                    <Row className="mb-3">
                                        <label
                                            htmlFor="member"
                                            className="col-md-2 col-form-label"
                                        >
                                            Sales owner
                                        </label>
                                        <div className="col-md-3">
                                            <Select
                                                classNamePrefix="select2-selection"
                                                name="salesOwner"
                                                placeholder="Select sales owner"
                                                options={
                                                    adminList ? adminList?.map(c => ({ value: c.userNo, label: capitalize(c.userName) })) : []
                                                }
                                                value={
                                                    filterValidation.values.salesOwner && adminList ?
                                                        adminList
                                                            ?.filter(c => c.userNo == filterValidation.values.salesOwner)
                                                            .map(c => ({ value: c.userNo, label: capitalize(c.userName) }))
                                                        : ""
                                                }
                                                isClearable
                                                isSearchable
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                onChange={(selectedOption) => {
                                                    filterValidation.setFieldValue("salesOwner", selectedOption ? selectedOption.value : null)
                                                }}
                                            />


                                        </div>
                                    </Row>
                                }
                                <Row className='mb-3' style={{ alignItems: "center" }}>
                                    <label className="col-md-2 col-form-label">
                                        WE subscribed
                                    </label>
                                    <div className="col-md-2 form-check" style={{ paddingLeft: '2em' }}>
                                        <input type="radio" className="form-check-input"
                                            id="weYnBoth"
                                            name="weYn"
                                            value="Both"
                                            onChange={filterValidation.handleChange}
                                            checked={filterValidation.values.weYn === "Both"}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="weYnBoth"
                                        >
                                            Both
                                        </label>
                                    </div>
                                    <div className="col-md-2 form-check" style={{ paddingLeft: '2em' }}>
                                        <input type="radio" className="form-check-input"
                                            id="weYnY"
                                            name="weYn"
                                            value="Y"
                                            onChange={filterValidation.handleChange}
                                            checked={filterValidation.values.weYn === "Y"}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="weYnY"
                                        >
                                            Yes
                                        </label>
                                    </div>
                                    <div className="col-md-2 form-check" style={{ paddingLeft: '2em' }}>
                                        <input type="radio" className="form-check-input"
                                            id="weYnN"
                                            name="weYn"
                                            value="N"
                                            onChange={filterValidation.handleChange}
                                            checked={filterValidation.values.weYn === "N"}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="weYnN"
                                        >
                                            No
                                        </label>
                                    </div>
                                </Row>
                                <Row className='mb-3' style={{ alignItems: "center" }}>
                                    <label className="col-md-2 col-form-label">
                                        Account type
                                    </label>
                                    <div className="col-md-2 form-check" style={{ paddingLeft: '2em' }}>
                                        <input type="checkbox" className="form-check-input"
                                            id='PR'
                                            name="accountTypes"
                                            value="PR"
                                            onChange={filterValidation.handleChange}
                                            checked={filterValidation.values.accountTypes.includes("PR")}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="PR"
                                        >
                                            Member
                                        </label>
                                    </div>
                                    <div className="col-md-2 form-check" style={{ paddingLeft: '2em' }}>
                                        <input type="checkbox" className="form-check-input"
                                            id='PT'
                                            name="accountTypes"
                                            value="PT"
                                            onChange={filterValidation.handleChange}
                                            checked={filterValidation.values.accountTypes.includes("PT")}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="PT"
                                        >
                                            Trial
                                        </label>
                                    </div>
                                    <div className="col-md-2 form-check" style={{ paddingLeft: '2em' }}>
                                        <input type="checkbox" className="form-check-input"
                                            id='FR'
                                            name="accountTypes"
                                            value="FR"
                                            onChange={filterValidation.handleChange}
                                            checked={filterValidation.values.accountTypes.includes("FR")}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="FR"
                                        >
                                            Free
                                        </label>
                                    </div>
                                </Row>
                                <Row>
                                    <label htmlFor="inscribedDate" className="col-md-2 col-form-label" style={{ paddingTop: '0px' }}>
                                        Sub start date
                                    </label>
                                    <div className="col-md-10">
                                        <PeriodBtn
                                            formik={filterValidation}
                                        />
                                    </div>
                                </Row>
                                <Row >
                                    <Col md={2}>&nbsp;</Col>
                                    <Col md={3}>&nbsp;</Col>
                                    <Col md={3}>
                                        <button
                                            type="button"
                                            className="btn btn-primary waves-effect waves-light col-md-5"
                                            onClick={() => {
                                                filterValidation.setFieldValue("curPage", 1);
                                                filterValidation.setFieldValue("submitType", "view");
                                                filterValidation.handleSubmit(filterValidation.values);
                                            }}
                                        >
                                            Search
                                        </button>
                                    </Col>
                                </Row>
                            </div>
                        </Collapse>
                    </Card>
                </Col>
            </Row>
            {
                noticeStr &&
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <CardTitle className="text-muted mb-0">
                                    <p style={{ whiteSpace: "pre" }}>
                                        {noticeStr}
                                    </p>
                                </CardTitle>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            }
            {
                Array.isArray(statisticsList) && statisticsList.length > 0 &&
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardTitle className="text-muted mt-3" style={{ paddingLeft: "25px" }}>
                                <span>
                                    Displaying statistics based on the activity during period: {statFromDate} to {statToDate}
                                </span>
                            </CardTitle>
                            <CardBody>
                                <div className="table-responsive">
                                    <Table className="table mb-0">
                                        <thead>
                                            <tr>
                                                {
                                                    columns.map(col => {
                                                        return (
                                                            <th key={col.label} style={!col.isSortable ? {verticalAlign: "middle"} : {}}>
                                                                <div style={col.thSyle}>
                                                                    <span>{col.label}</span>
                                                                    {col.isSortable && <span style={{ display: 'flex', flexDirection: "column", gap: "3px", justifyContent: "center", alignItems: "center" }}>
                                                                        <Link
                                                                            to='#'
                                                                            onClick={() => {
                                                                                filterValidation.setFieldValue("sort", col.sortAsc)
                                                                                filterValidation.setFieldValue("submitType", "view")
                                                                                filterValidation.handleSubmit(filterValidation.values)
                                                                                console.log(filterValidation)
                                                                            }}
                                                                            className={filterValidation.values.sort == col.sortAsc ? "text-danger" : ""}
                                                                        >
                                                                            <i className="uil uil-angle-up font-size-18"></i>
                                                                        </Link>
                                                                        <Link
                                                                            to='#'
                                                                            onClick={() => {
                                                                                filterValidation.setFieldValue("sort", col.sortDesc)
                                                                                filterValidation.setFieldValue("submitType", "view")
                                                                                filterValidation.handleSubmit(filterValidation.values)
                                                                                console.log(filterValidation)
                                                                            }}
                                                                            className={filterValidation.values.sort == col.sortDesc ? "text-danger" : ""}
                                                                        >
                                                                            <i className="uil uil-angle-down font-size-18"></i>
                                                                        </Link>
                                                                    </span>}
                                                                </div>
                                                            </th>
                                                        )
                                                    })
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                statisticsList.map((info, index) => {
                                                    return (
                                                        <tr key={info.chkDate}>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>{info.organization || "-"}</td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center", width: "200px", wordBreak: "break-word", overflowWrap: "anywhere" }}>{info.userName || "-"}</td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>{
                                                                info.subscriptionType == "JN" ? "Madrid"
                                                                    : info.subscriptionType == "HN" ? "Hague"
                                                                        : info.subscriptionType == "PCT" ? "PCT"
                                                                            : "-"
                                                            }</td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>{info.subscriptionType == 'JN' || info.subscriptionType == 'HN' ? info.jurisdiction : '-'}</td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                {accountTypesInfo[info.subscriptionCategory] || "-"}
                                                            </td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>{info.startDate || "-"}</td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>{info.endDate || "-"}</td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>{info.weStart || "-"}</td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>{info.casesUploaded}</td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>{info.casesContacted}</td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>{info.emailsSent}</td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>{info.lastContactDate || "-"}</td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>{
                                                                info.subscriptionType == 'JN' || info.subscriptionType == 'HN'
                                                                    ? Math.min(info.sendRate, 100) + "%"
                                                                    : "-"
                                                            }</td>
                                                            <td style={{ verticalAlign: "middle" }}>
                                                                {
                                                                    adminList && adminList.length > 0 &&
                                                                    <Select
                                                                        classNamePrefix="select2-selection"
                                                                        placeholder="Select sales owner"
                                                                        options={
                                                                            adminListOptions
                                                                        }
                                                                        value={
                                                                            info.salesOwner && adminList ?
                                                                                adminList
                                                                                    ?.filter(c => c.userNo == info.salesOwner)
                                                                                    .map(c => ({ value: c.userNo, label: capitalize(c.userName) }))[0] || null
                                                                                : {value: "", label: "Please designate a sales owner"}
                                                                        }
                                                                        isSearchable
                                                                        menuPlacement="auto"
                                                                        menuPosition="fixed"
                                                                        styles={{
                                                                            control: (base) => ({
                                                                                ...base,
                                                                                width: 170,
                                                                            }),

                                                                            menu: (base) => ({
                                                                                ...base,
                                                                                width: 200,
                                                                            }),
                                                                        }}
                                                                        onChange={(selectedOption) => {
                                                                            if (selectedOption.value != (info.salesOwner == null ? "" : info.salesOwner)) {
                                                                                setSalesOwnerUpdate({ userNo: info.userNo, userName: info.userName, salesOwner: selectedOption ? selectedOption.value : null, salesOwnerName: selectedOption ? selectedOption.label : null })
                                                                            }
                                                                        }}
                                                                    />
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="d-flex justify-content-between" style={{ marginTop: "20px" }}>
                                    <span className="d-flex align-items-center gap-2">
                                        <label
                                            htmlFor="perPage"
                                        >
                                            Entries per page
                                        </label>
                                        <div style={{ width: "100px" }}>
                                            <select
                                                className="form-select"
                                                name="perPage"
                                                onChange={e => { onPageChange(1, e.target.value); }}
                                                value={filterValidation.values.perPage}
                                            >
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="30">30</option>
                                                <option value="40">40</option>
                                                <option value="50">50</option>
                                            </select>
                                        </div>
                                    </span>
                                    <span className="d-flex align-items-center gap-2">
                                        <div className="d-flex gap-1">
                                            <Button
                                                type="button"
                                                color="primary"
                                                onClick={() => { onPageChange(1, filterValidation.values.perPage); }}
                                                disabled={(filterValidation.values.curPage == 1)}
                                            >
                                                {"<<"}
                                            </Button>
                                            <Button
                                                type="button"
                                                color="primary"
                                                onClick={() => { onPageChange(Number(filterValidation.values.curPage) - 1, filterValidation.values.perPage); }}
                                                disabled={(filterValidation.values.curPage == 1)}
                                            >
                                                {"<"}
                                            </Button>
                                        </div>
                                        Page{" "}
                                        <strong>
                                            {filterValidation.values.curPage} of {totalPage}
                                        </strong>

                                        <Input
                                            type="number"
                                            min={1}
                                            style={{ width: 70 }}
                                            max={totalPage}
                                            name="curPage"
                                            defaultValue={filterValidation.values.curPage}
                                            value={filterValidation.values.curPage}
                                            onChange={(e) => {
                                                const _curPage = Math.min(Math.max(e.target.value, 1), totalPage)
                                                // setCurPageInput(_curPage, totalPage)
                                                filterValidation.setFieldValue("curPage", _curPage);
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    const _curPage = Math.min(Math.max(e.target.value, 1), totalPage)
                                                    onPageChange(_curPage, filterValidation.values.perPage);
                                                }
                                            }}
                                        />
                                        <div className="d-flex gap-1">
                                            <Button
                                                type="button"
                                                color="primary"
                                                onClick={() => { onPageChange(Number(filterValidation.values.curPage) + 1, filterValidation.values.perPage); }}
                                                disabled={(filterValidation.values.curPage == totalPage)}
                                            >
                                                {">"}
                                            </Button>
                                            <Button
                                                type="button"
                                                color="primary"
                                                onClick={() => { onPageChange(totalPage, filterValidation.values.perPage); }}
                                                disabled={(filterValidation.values.curPage == totalPage)}
                                            >
                                                {">>"}
                                            </Button>
                                        </div>
                                    </span>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            }

            {
                salesOwnerUpdate && salesOwnerUpdate?.userNo ? (
                    <SweetAlert
                        title="Are you sure?"
                        warning
                        showCancel
                        confirmBtnText="Confirm"
                        cancelBtnText="No, go back"
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => {
                            dispatch(
                                updateSalesOwner({
                                    param: salesOwnerUpdate,
                                    filter: {
                                        limit: filterValidation.values.perPage,
                                        curPage: filterValidation.values.curPage,
                                        member: filterValidation.values.member,
                                        weYn: filterValidation.values.weYn,
                                        fromDate: filterValidation.values.fromDate ? filterValidation.values.fromDate.replace(/-/g, "") : "",
                                        toDate: filterValidation.values.toDate ? filterValidation.values.toDate.replace(/-/g, "") : "",
                                        accountTypes: filterValidation.values.accountTypes,
                                        salesOwner: filterValidation.values.salesOwner,
                                        sortType: filterValidation.values.sort
                                    }
                                })
                            )
                            setSalesOwnerUpdate(null)
                        }}
                        onCancel={() => setSalesOwnerUpdate(null)}
                    >
                        {
                            salesOwnerUpdate.salesOwner ?
                                <>Do you want to update the sales owner of member <span style={{ fontWeight: 'bold' }}>{salesOwnerUpdate.userName}</span> to <span style={{ fontWeight: 'bold' }}>{salesOwnerUpdate.salesOwnerName}</span></>
                                :
                                <>Do you want to remove the sales owner of member <span style={{ fontWeight: 'bold' }}>{salesOwnerUpdate.userName}</span></>
                        }
                    </SweetAlert>
                )
                    : null
            }
        </TabPane>
    )

}


export default MemberStatistics;